/*
 * NSE Phase 1 search preview (2026-10-29): voice search for the header search bar.
 * - Uses the browser's Web Speech API (SpeechRecognition / webkitSpeechRecognition). No paid service, no API key.
 * - The mic button stays hidden where the API is not supported.
 * - Listening starts ONLY when the shopper taps the mic, after a one-time consent notice
 *   (stored in localStorage as 'nse-voice-consent'). One phrase per tap; no continuous listening.
 * - The transcript fills the search box, shows predictive suggestions, then runs the search.
 */
(function () {
  var CONSENT_KEY = 'nse-voice-consent';
  var Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;

  function hasConsent() {
    try {
      return window.localStorage.getItem(CONSENT_KEY) === 'yes';
    } catch (e) {
      return false;
    }
  }

  function saveConsent() {
    try {
      window.localStorage.setItem(CONSENT_KEY, 'yes');
    } catch (e) {
      /* storage blocked: ask again next time */
    }
  }

  function init(root) {
    if (root.dataset.nseVoiceReady) return;
    root.dataset.nseVoiceReady = 'true';

    var button = root.querySelector('[data-nse-voice]');
    var input = root.querySelector('input[type="search"]');
    var status = root.querySelector('[data-nse-voice-status]');
    var consent = root.querySelector('[data-nse-voice-consent]');
    if (!button || !input) return;

    // Hide the mic where speech recognition is not available (e.g. Firefox, insecure pages).
    if (!Recognition || !window.isSecureContext) {
      button.hidden = true;
      return;
    }
    button.hidden = false;

    var recognition = null;
    var listening = false;

    function say(text) {
      if (status) status.textContent = text;
    }

    function setListening(on) {
      listening = on;
      button.classList.toggle('nse-voice__button--listening', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.setAttribute('aria-label', on ? 'Stop voice search' : 'Search by voice');
    }

    function runSearch(text) {
      input.value = text;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
      say('Searching for ' + text);
      var form = input.form;
      if (!form) return;
      // Give the predictive dropdown a moment, then run the full search.
      setTimeout(function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }, 600);
    }

    function start() {
      if (listening) {
        if (recognition) recognition.stop();
        return;
      }
      recognition = new Recognition();
      recognition.lang = document.documentElement.lang || 'en-US';
      recognition.interimResults = false;
      recognition.continuous = false;
      recognition.maxAlternatives = 1;

      recognition.onstart = function () {
        setListening(true);
        say('Listening. Say a machine, brand or process.');
      };
      recognition.onresult = function (event) {
        var result = event.results && event.results[0] && event.results[0][0];
        var text = result ? String(result.transcript || '').trim() : '';
        if (text) runSearch(text);
      };
      recognition.onerror = function (event) {
        var code = event && event.error;
        if (code === 'not-allowed' || code === 'service-not-allowed') {
          say('Microphone access was blocked. You can type your search instead.');
        } else if (code === 'no-speech') {
          say('No speech heard. Tap the mic to try again.');
        } else {
          say('Voice search is unavailable right now. You can type your search instead.');
        }
      };
      recognition.onend = function () {
        setListening(false);
        recognition = null;
      };
      try {
        recognition.start();
      } catch (e) {
        setListening(false);
      }
    }

    function openConsent() {
      if (!consent) return start();
      consent.hidden = false;
      var accept = consent.querySelector('[data-nse-voice-accept]');
      if (accept) accept.focus();
    }

    function closeConsent() {
      if (consent) consent.hidden = true;
      button.focus();
    }

    if (consent) {
      consent.querySelector('[data-nse-voice-accept]').addEventListener('click', function () {
        saveConsent();
        consent.hidden = true;
        button.focus();
        start();
      });
      consent.querySelector('[data-nse-voice-cancel]').addEventListener('click', closeConsent);
      consent.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeConsent();
      });
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (hasConsent()) start();
      else openConsent();
    });
  }

  function initAll() {
    document.querySelectorAll('.nse-searchbar').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
